import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Input, Label, Select } from 'theme-ui'

const FieldWithLabel = ({
  as: Control = Input,
  isSelect,
  isDatepicker,
  label,
  id,
  name,
  className,
  children,
  onChange,
  props,
  type,
  value,
  maxLength,
  placeholder,
  error,
  noWrap,
  onClick,
  onKeyUp,
}) => {
  const { t } = useTranslation();
  const fieldIdentifier = id || name;
  const wrapClass = noWrap ? 'field-with-labels--nowrap' : '';

  return (
    <Box className={`field-with-labels ${className} ${wrapClass}`}>
      <Label htmlFor={fieldIdentifier}>{label}</Label>
      {!isSelect && !isDatepicker && (
        <Control
          id={fieldIdentifier}
          name={name}
          type={type}
          placeholder={placeholder}
          onChange={onChange}
          className={error && 'field-error'}
          maxLength={maxLength}
          value={value}
          onKeyUp={onKeyUp}
        />
      )}
      {isSelect && (
        <Select
          className={error && 'field-error'}
          value={value}
          {...props}
          onChange={onChange}
          onClick={onClick}
        >
          {children}
        </Select>
      )}
      {isDatepicker && <>{children}</>}
      {error && <span sx={{ color: 'error' }}>{t('fieldRequired')}</span>}
    </Box>
  );
};

export default FieldWithLabel;
